import axios from '@/js/plugins/client'
export default {
  alias      : 'enlace_externo',
  route      : '/app/tramite/enlace_externo',
  hash       : false,
  store      : false,
  key        : 'id',
  name       : 'token',
  selectable : false,
  default    : {
    id                     : null,
    token                  : null,
    dependencia_id         : null,
    ru                     : null,
    detalle                : null,
    firma                  : null,
    cargo                  : null,
    usuario_id             : null,
    dependencia_usuario_id : null,
    email                  : null,
    domicilio              : null,
    telefono               : null,
    contrato               : null,
    fecha_inicio           : null,
    plazo                  : 0,
    plazo_extemporaneo     : 0,
    cantidad_documentos    : 0,
    documentos             : [],
    created_at             : null,
    updated_at             : null,
  },
  methods : {
    showExterno(id, token) {
      return new Promise((resolve, reject) => {
        let params={token: token}
        axios.get('/tramite/enlace_externo/'+id, {params: params}).then(response => {
          resolve(response)
        })
          .catch(reject)
      })
    },
    crearDocumentoExterno(id, token, form) {
      let params={...form, token: token}
      return axios.post('/tramite/enlace_externo/'+id, params)
    },
  }
}
  